export default {
  loadingDataOnPageLoad: null,
  items: [],
  displayableItemCount: 0,
  indicatives: {}
};
